import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { EOnboardingTaskState } from '@feathr/blackbox';
import type { TTheme } from '@feathr/components';
import { themeToStyle } from '@feathr/components/src/style';

import * as styles from './MilestoneTaskStatus.css';

interface IMilestoneTaskStatus {
  label: string;
  theme: TTheme;
}

interface IMilestoneTaskProps {
  status: EOnboardingTaskState;
}

function MilestoneTaskStatus({ status }: Readonly<IMilestoneTaskProps>): JSX.Element {
  const { t } = useTranslation();

  const statusMap: Record<EOnboardingTaskState, IMilestoneTaskStatus> = {
    [EOnboardingTaskState.NotStarted]: {
      label: t('New'),
      theme: 'slate',
    },
    [EOnboardingTaskState.InProgress]: {
      label: t('Pending'),
      theme: 'yellow',
    },
    [EOnboardingTaskState.Completed]: {
      label: t('Completed'),
      theme: 'green',
    },
    [EOnboardingTaskState.Skipped]: {
      label: t('Skipped'),
      theme: 'green',
    },
  };

  return (
    <div
      className={styles.root}
      style={themeToStyle({ rule: '--l-color-text', shade: 700, theme: statusMap[status].theme })}
    >
      {statusMap[status].label}
    </div>
  );
}

export default MilestoneTaskStatus;
